/**
 * Global Notifications - Constants & Translations
 */

import type { NotificationType } from '@/types/notifications.types';

export const NOTIFICATION_TYPE_ICONS: Record<NotificationType, string> = {
  deal_event: '📋',
  document: '📄',
  message: '💬',
  expert: '👨‍💼',
  lender: '🏦',
  pre_eval: '📊',
  cim: '📑',
  nda: '🔒',
  loi: '✍️',
  meeting: '📅',
  system: '⚙️',
};

export const NOTIFICATION_TRANSLATIONS = {
  en: {
    notifications: 'Notifications',
    markAllRead: 'Mark all as read',
    viewAll: 'View all notifications',
    noNotifications: 'No notifications',
    noNewNotifications: 'You\'re all caught up!',
    justNow: 'Just now',
    minutesAgo: 'min ago',
    hoursAgo: 'h ago',
    daysAgo: 'd ago',
    unread: 'unread',
    settings: 'Notification Settings',
    emailNotifications: 'Email Notifications',
    smsNotifications: 'SMS Notifications',
    pushNotifications: 'Push Notifications',
    quietHours: 'Quiet Hours',
    dealEvents: 'Deal Events',
    documents: 'Documents',
    messages: 'Messages',
    experts: 'Expert Updates',
    lenders: 'Lender Offers',
    meetings: 'Meetings',
    types: {
      deal_event: 'Deal Event',
      document: 'Document',
      message: 'Message',
      expert: 'Expert',
      lender: 'Lender',
      pre_eval: 'Pre-Evaluation',
      cim: 'CIM',
      nda: 'NDA',
      loi: 'LOI',
      meeting: 'Meeting',
      system: 'System',
    },
  },
  fr: {
    notifications: 'Notifications',
    markAllRead: 'Tout marquer comme lu',
    viewAll: 'Voir toutes les notifications',
    noNotifications: 'Aucune notification',
    noNewNotifications: 'Vous êtes à jour !',
    justNow: 'À l\'instant',
    minutesAgo: 'min',
    hoursAgo: 'h',
    daysAgo: 'j',
    unread: 'non lues',
    settings: 'Paramètres de notification',
    emailNotifications: 'Notifications par email',
    smsNotifications: 'Notifications par SMS',
    pushNotifications: 'Notifications push',
    quietHours: 'Heures silencieuses',
    dealEvents: 'Événements de deal',
    documents: 'Documents',
    messages: 'Messages',
    experts: 'Mises à jour experts',
    lenders: 'Offres de prêteurs',
    meetings: 'Réunions',
    types: {
      deal_event: 'Événement de deal',
      document: 'Document',
      message: 'Message',
      expert: 'Expert',
      lender: 'Prêteur',
      pre_eval: 'Pré-évaluation',
      cim: 'CIM',
      nda: 'NDA',
      loi: 'LOI',
      meeting: 'Réunion',
      system: 'Système',
    },
  },
};
